import { UseQueryOptions, useSuspenseQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { GuidesBySearchQueryResult } from "@shared/sanity/types";

interface GuidesQueryParams {
  search: string;
  page: number;
  limit: number;
}

interface UseOrderOptions
  extends Omit<
    UseQueryOptions<
      GuidesBySearchQueryResult,
      Error,
      GuidesBySearchQueryResult,
      ["guides", "feature", GuidesQueryParams]
    >,
    "queryKey" | "queryFn"
  > {
  queryParams: GuidesQueryParams;
}

export const useGuidesBySearch = (options: UseOrderOptions) => {
  const { queryParams } = options;

  return useSuspenseQuery({
    queryKey: ["guides", "feature", queryParams],
    queryFn: async ({ signal }): Promise<GuidesBySearchQueryResult> => {
      const response = await axiosInstance.get(`/guides`, {
        signal,
        params: queryParams,
      });

      return response.data;
    },
    ...options,
  });
};
